import { Lookup, LookupItem } from "@data-types";
import { httpClient, retryRequest } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class PlatformTitlesApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/user-titles`;
	}

	static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findTitles(): Promise<Lookup<LookupItem>> {
		const response = await retryRequest(() =>
			httpClient.get(
				`${this.baseUrl}?translate=true`,
				this.getRequestHeaders()
			)
		);

		return response;
	}
}

export default PlatformTitlesApiService;
